<script setup lang="ts">
import { useI18n} from "vue-i18n";
const  i18n  = useI18n()
const  localePath = useLocalePath()

const route = useRoute();

const { data } = await useFetch("/api/locations/locations.json");

const placeList = data.value
  .filter((place: any) => place.urlState === route.params.state)
  .sort((a: any, b: any) => {
    if (a.StationName < b.StationName) {
      return -1;
    }
    if (a.StationName > b.StationName) {
      return 1;
    }
    return 0;
  });
</script>

<script lang="ts">
export default { name: "DirectoryState" };
</script>


<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>{{ i18n.t('general.placeClimateTitle',{place: placeList[0].stateName}) }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-breadcrumbs
          :items="[
            { title: i18n.t('navigation.home'), to: localePath('/') },
            { title: 'United States', to: localePath('/places/dir/united-states') },
            {
              title: placeList[0].stateName,
              to: localePath(`/places/dir/united-states/${route.params.state}/`),
            },
          ]"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ul>
          <li
            v-for="place in placeList"
            :key="place.location"
          >
            <nuxt-link
              :to="localePath(`/climate/summary/united-states/${route.params.state}/${place.urlName}/`)"
            >
              {{ place.StationName }}, {{ place.cityName }}
            </nuxt-link>
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped lang="scss">
li {
  list-style: none;
  margin-bottom: 0.5rem;
}
</style>
